import { clearStorageData, getStorageData, setStorageData } from "@/utils/storage";
import _get from "lodash.get";
import {
  login as apiLoginUser,
  me as apiMe,
  myProfile as apiMyProfile,
  resetPassword as apiResetPassword,
  resetPasswordVerify as apiResetPasswordVerify,
  forgotPassword as apiForgotPassword
} from "@api/user";

const STORAGE_USER_KEY = "user";

const userStore = {
  namespaced: true,
  state: {
    user: getStorageData(STORAGE_USER_KEY)
  },
  mutations: {
    logoutUser() {
      //clear store
      clearStorageData('local');
      clearStorageData('session');
    },
    setUser(state, payload) {
      const data = {
        ...state.user,
        ...payload
      };

      // data.acl.roles.forEach(role => {
      //   const roleName = `is${_capitalize(role)}`
      //   data.acl[roleName] = true;
      // });

      state.user = data;

      setStorageData(STORAGE_USER_KEY, state.user);
    }
  },
  actions: {
    async loginUser({ commit, dispatch }, { userData }) {

      try {
        const apiLoginResponse = await apiLoginUser(userData);
        const jwt = _get(apiLoginResponse, "data.access_token");

        const updatedUserData = {
          jwt,
          isLocked: false
        };

        commit("setUser", updatedUserData);

        const response = await apiMe();

        const { data: myCompanyProfile } = await apiMyProfile();

        commit("setUser", {
          ...updatedUserData,
          ...response.data
        });

        commit(
          "companyStore/setCompany",
          {
            ...myCompanyProfile
          },
          { root: true }
        );

        dispatch('systemStore/setRevision', {}, {root:true});

        return;
      } catch (error) {
        const errorResponse = _get(error, "response", {});
        const statusError = _get(errorResponse, "status");

        if (statusError === 305) {
          const redirect_to = _get(errorResponse, "data.redirect_to");
          if (redirect_to) {
            setStorageData("redirect", {redirect_to:redirect_to});
            return;
          }
        }

        throw error;
      } finally {
      }
    },
    async updateUser({ commit }, user) {
      const { data: updatedUser } = await apiMe("put", user);
      return commit("setUser", updatedUser);
    },
    async logoutUser({ commit }) {
      commit("logoutUser");
    },
    async resetPassword({}, { userData }) {
      try {
        const response = await apiResetPassword(userData);
        return response;
      } catch (error) {
        throw error;
      } finally {
      }
    },
    async resetPasswordVerify({}, data) {
      
      try {
        const response = await apiResetPasswordVerify(data);
        return response;
      } catch (error) {
        throw error;
      } finally {
        
      }
    },
    async forgotPassword({}, data) {
      const { token } = data;
      const { password, password_confirmation } = data;
      
      try {
        const response = await apiForgotPassword(token, { password, password_confirmation });
        return response;
      } catch (error) {
        throw error;
      } finally {
        
      }
    },
  },
  getters: {
    user(state) {
      return state.user;
    }
  }
};

export default userStore;
